<template>
	<div class="footer-content">
		<div class="footer_top">
			<div class="footer_top_list">
				<p class="footer_top_title">联系我们</p>
				<div class="footer_top_content">
					<div class="footer_top_pop" v-for="item in contact" :key="item.name">{{ item.name }}</div>
					<div class="footer_top_ren">
						<span>
							兰州科技大市场 版权所有：Copyright © 2015
							备案信息：陇ICP备15000785号-1
						</span>
						<span>甘公网安备62010202000609号</span>
					</div>
				</div>
			</div>

			<div class="footer_top_list">
				<div class="footer_top_content">
					<img class="code" src="../assets/back.png" />
					<!-- <div class="footer_top_pop1">关注微信公众号</div> -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				contact: [{
						name: "邮编：730000"
					},
					{
						name: "电话：0931-8731059，0931-8271700"
					},
					{
						name: "邮箱：LZKJDSC@163.com"
					},
					{
						name: "地址：兰州市高新技术产业 开发区雁南南路279号 科庆综合楼"
					}
				]
			};
		}
	};
</script>
<style lang="scss" scoped>
	.footer-content {
		height: 280px;
		margin: auto;
		margin-top:60px;
        background:#2A2A2B;
		.footer_top {
			width: 1200px;
			height: 100%;
			margin: auto;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;

			.footer_top_list {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
				flex-direction: column;
				margin-top: 70px;

				.footer_top_title {
					padding: 0;
					margin: 0;
					font-size: 20px;
					font-family: Alibaba PuHuiTi;
					font-weight: 400;
					color: rgba(255, 255, 255, 1);
					margin-bottom: 30px;
				}

				.footer_top_content {
					.footer_top_pop {
						text-align: left;
						float: left;
						width: 50%;
						font-size: 16px;
						font-family: Alibaba PuHuiTi;
						font-weight: 400;
						color: rgba(255, 255, 255, 1);
						line-height: 25px;
						opacity: 0.3;
					}

					.footer_top_pop:nth-of-type(1) {
						width: 35%;
					}

					.footer_top_pop:nth-of-type(3) {
						width: 35%;
					}

					.footer_top_ren {
						float: left;
						font-size: 16px;
						font-family: Alibaba PuHuiTi;
						font-weight: 400;
						color: rgba(255, 255, 255, 1);
						opacity: 0.5;
						margin-top: 40px;

						span:nth-last-of-type(1) {
							margin-left: 32px;
						}
					}

					.code {
						width: 110px;
						height: 110px;
						object-fit: cover;
					}

					.footer_top_pop1 {
						width: 120px;
						font-size: 16px;
						font-family: Alibaba PuHuiTi;
						font-weight: 400;
						color: rgba(255, 255, 255, 1);
						opacity: 0.3;
						margin-top: 14px;
					}
				}
			}
		}
	}
</style>
